var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93826 0.952173C5.73891 -0.0486407 7.26109 -0.048641 8.06174 0.952172L11.9005 5.75061C12.9481 7.06014 12.0158 9 10.3387 9H2.66125C0.984237 9 0.0518899 7.06014 1.09951 5.75061L4.93826 0.952173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygon);
export default __webpack_public_path__ + "static/media/icon-polygon.c991c64a0122442eb9a47c3394b88e09.svg";
export { ForwardRef as ReactComponent };